/**
 * ThemeSwitch (entry IIFE) — módulo Vite consumido pelo legado pela tag `<theme-switch>`, que
 * `article_template/content_header.php` emite. Os nomes de cookie, valor e classe são
 * constantes do legado (`AST_THEME_*`) e chegam por `data-*`. Não carrega CSS: a aparência
 * está no módulo `ArticleTemplate`.
 */
import React from 'react';

import { createRoot } from 'react-dom/client';

import ThemeSwitch from '../../components/container/ThemeSwitch/ThemeSwitch';

const mountThemeSwitch = (element: HTMLElement): void => {
    const ds = element.dataset;

    // Sem os nomes do legado o controle não tem o que alternar nem onde gravar.
    if (!ds.cookie || !ds.bodyClass) return;

    createRoot(element).render(
        <ThemeSwitch
            cookieName={ds.cookie}
            darkValue={ds.darkValue || 'dark'}
            lightValue={ds.lightValue || 'light'}
            bodyClass={ds.bodyClass}
            lang={ds.lang}
        />
    );
};

(() => {
    const elements = document.querySelectorAll<HTMLElement>('theme-switch');

    elements.forEach(mountThemeSwitch);
})();
